/**************************************************************************************************/
/*   File: /src/app/shared/components/map/map.component.ts                                        */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed Apr 17 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';

import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, NgZone, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';

import * as fromRootStates from '../../../stores/states/root';

/**
 * The component for map
 */
@Component({
  selector: 'nwpl-frnt-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnChanges {

  /**
   * True if drawing is enabled
   */
  activeDraw = true;

  /**
   * The full screen mode
   */
  isFullScreen = false;
  /**
   * The language
   */
  @Input() language: string;

  /**
   * If draw is done
   */
  @Input() drawDone: boolean;

  /**
   * If true disable all controls
   */
  @Input() disableAll: boolean;

  /**
   * The selected plan type code
   */
  @Input() planType: string;

  /**
   * The array of ambiti
   */
  @Input() ambiti: string[];

  /**
   * The optional context for the map
   */
  @Input() contextId: string;

  /**
   * The optional dossier for the map
   */
  @Input() dossierId: string;

  @Input() dossierExtent: string;
  /**
   * The output emitter for selected geometries
   */
  @Output() selectedGeometries: EventEmitter<any> = new EventEmitter();

  /**
   * The output emitter for resetted geometries
   */
  @Output() resettedGeometries: EventEmitter<any> = new EventEmitter();

  /**
   * The full screen event
   */
  @Output() fullScreened: EventEmitter<boolean> = new EventEmitter();

  /**
   * The data obtained from maps
   */
  dataFromMaps: any;

  /**
   * The constructor
   * @param zone The zone
   * @param logger the logger
   */
  constructor(private http: HttpClient, private store: Store<fromRootStates.RootState>, private zone: NgZone, private logger: NGXLogger) {
  }

  /**
   * The ng on changes hook
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.planType) {
      this.logger.trace('Plan type is', changes.planType.currentValue);
    }
  }


  /**
   * On selected data
   * @param data The data
   */
  onSelected(data: any) {
    if (data) {
      this.dataFromMaps = data;
    }

    if (this.dataFromMaps) {
      this.selectedGeometries.emit(this.dataFromMaps.mapsSelectedWkt);
    }
  }

  /**
   * On click over select geometries
   * @param  $event the event
   */
  onSelectPressed($event: Event) {
    if (this.dataFromMaps && this.dataFromMaps.mapsSelectedWkt) {
      this.selectedGeometries.emit(this.dataFromMaps.mapsSelectedWkt);
    }
  }

  /**
   * On click over reset geometries
   * @param  $event the event
   */
  onResetPressed($event: Event) {
    // this.featureGroup.clearLayers();
    this.dataFromMaps = undefined;
    this.activeDraw = true;
    this.resettedGeometries.emit($event);
    this.drawDone = false;
  }

  /**
   * On full screened
   * @param $event boolean for fullScreen
   */
  onFullScreened($event: boolean) {
    this.isFullScreen = $event;
    this.fullScreened.emit($event);
  }


}
